<template>
  <div class="auteur">
    <figure v-if="image" class="auteur--blog-img">
      <img :src="image" class="object-cover">
    </figure>

    <main class="px-4 py-5">
      <section class="flex mb-4">
        <figure v-if="author.avatarUrl" class="auteur--img">
          <img :src="author.avatarUrl" class="object-cover">
        </figure>
        <div class="flex flex-col font-bold pl-6 pt-8">
          <span>Geschreven door:</span>
          <span>{{ author.name }}</span>
          <nuxt-link v-if="author.profiel" :to="{name: 'ouders-begeleiders-slug', params: {slug: author.profiel.slug}}" class="text-xs link-secondary">
            Bekijk profiel
          </nuxt-link>
        </div>
      </section>
      <p>
        {{ author.introductie }}
      </p>
    </main>
  </div>
</template>

<script>
export default {
  props: {
    author: {
      type: Object,
      default: () => ({}),
    },
    image: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.auteur {
  @apply w-full bg-white;
  min-height: 600px;
  @screen sm {
    width: 500px;
  }
  @screen lg {
    width: 325px;
    min-height: 900px;
  }
  @screen xl {
    width: 400px;
  }
  box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.11);
  &--blog-img img, &--img img {
    @apply h-full w-full object-cover;
  }
  &--blog-img {
    height: 265px;
  }
  &--img {
    height: 140px;
    width: 140px;
  }
}
</style>
